import { useColumnsWithSort, useCommonCompensationColumns } from 'hooks';
import { sizeColumns } from 'helpers';

export const useCompensationTable = () => {
  const columns = useCommonCompensationColumns();
  const sizedColumns = sizeColumns(columns, ['20%', '20%', '40%', '20%']);
  const { columnsWithSort, onSorterChange } = useColumnsWithSort(sizedColumns, 'createdOn');

  return { columns: columnsWithSort, onSorterChange };
};
